"use client";

import { motion } from "framer-motion";

import { Badge } from "../ui/badge";
import { Breadcrumb } from "./breadcrumb";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  breadcrumbItems?: Array<{ label: string; href?: string }>;
}
export function PageHeader({
  title,
  subtitle,
  breadcrumbItems,
}: PageHeaderProps) {
  return (
    <header className="bg-gradient-primary relative mx-6 overflow-hidden rounded-lg">
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 md:py-12 lg:px-8">
        <motion.div
          className="header-content relative flex w-full items-center justify-between space-y-4"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="mb-0 text-3xl leading-none font-bold text-white md:text-6xl">
            {title}
          </h1>
          <Badge className="flex w-fit items-center rounded-full bg-white/20 px-4 text-sm tracking-wide md:text-base">
            {breadcrumbItems && <Breadcrumb items={breadcrumbItems} />}
            {subtitle && (
              <p className="max-w-xl text-lg leading-relaxed tracking-wide text-gray-500">
                {subtitle}
              </p>
            )}
          </Badge>
        </motion.div>
      </div>
    </header>
  );
}
